import React from "react";
import { Routes, Route } from "react-router-dom";
import TeacherSidebar from "../../../components/teacher/TeacherSidebar";
import Error404 from "../../errors/Error404";
import AllProjects from "../../common-pages/all-projects-page/AllProjects";
import OngoingProjectsList from "../ongoing-projects/ongoing-projects-list/OngoingProjectsList";
import EditProfile from "../profile-details/EditProfile";
import CreateNewProject from "../ongoing-projects/create-new-project/CreateNewProject";
import ProfilePageProjects from "../../common-pages/ProfilePageProjects";
import StarredProjects from "../../common-pages/StarredProjects";
import { ProjectDetailsPage } from "../../common-pages/project-details-page/ProjectDetailsPage";
import OngoingProjectDetails from "../ongoing-projects/ongoing-project-details/OngoingProjectDetails";

const TeacherContainer = () => {
  return (
    <>
      <div className="flex flex-row">
        <div className="h-screen sticky top-0 left-0 hidden lg:flex">
          <TeacherSidebar />
        </div>
        <Routes>
          <Route path="ongoing-projects" element={<OngoingProjectsList />} />
          <Route
            path="ongoing-projects/edai/project-details/:ongoingProjectId"
            element={<OngoingProjectDetails projectType="EDAI" />}
          />
          <Route
            path="ongoing-projects/sdp/project-details/:ongoingProjectId"
            element={<OngoingProjectDetails projectType="SDP" />}
          />
          <Route
            path="ongoing-projects/create-new-edai-project"
            element={<CreateNewProject projectType="EDAI" />}
          />
          <Route
            path="ongoing-projects/create-new-sdp-project"
            element={<CreateNewProject projectType="SDP" />}
          />
          <Route path="all-projects" element={<AllProjects />} />
          <Route
            path="guided-projects"
            element={<ProfilePageProjects role={"teacher"} />}
          />
          <Route
            path="starred-projects"
            element={<StarredProjects role={"teacher"} />}
          />
          <Route
            path="project-details/:projectId"
            element={<ProjectDetailsPage />}
          />
          <Route path="profile-details" element={<EditProfile />} />
          <Route
            path="*"
            element={<Error404 tabTitle="404 Page Not Found" />}
          />
        </Routes>
      </div>
    </>
  );
};

export default TeacherContainer;
